import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { get as lodashGet, isEmpty } from "lodash";
import { Field, reduxForm } from "redux-form";
import LoadingButton from "@mui/lab/LoadingButton";
import { InputLabel, Typography } from "@mui/material";

import { useAuth } from "src/providers/Auth";
import { formValidate, formState } from "./formValidate";
import { useFormValues } from "src/hooks/useFormValues";
import { renderField } from "src/components/renderField";
import Loading from "src/components/Loading";
import Timer from "./Timer";

import logoQa from "src/assets/qa_logo.png";
import { FormWrapper } from "./styled";

const Questionnaire = ({
  invalid,
  submitting,
  handleSubmit,
  onSubmit,
  isCodeVerified,
  getVerifyCode,
  getCode,
  submitVerifyCode,
  codeSubmitting,
  verifyError,
  setIsCodeVerified,
  setShowModal,
}) => {
  const [submitPhone, setSubmitPhone] = useState("");
  const { profile } = useAuth();
  const storesList = useSelector((state) => state.ajax.storesList);

  const formatStoreList = lodashGet(storesList, ["data", "rows"], [])
    .sort((a, b) => a.order - b.order)
    .reduce(
      (acc, { name }) => {
        acc.push({ label: name, value: name });
        return acc;
      },
      [{ label: "櫃點", value: "" }]
    );

  const { phone: phoneFormValue = "" } = useFormValues({
    fieldsNames: ["phone"],
    formName: "laPrairieForm",
  });
  const { gender } = useFormValues({
    fieldsNames: ["gender"],
    formName: "laPrairieForm",
  });

  const onPhoneChange = () => {
    setIsCodeVerified(false);
  };
  const sendVerify = () => {
    setSubmitPhone(phoneFormValue);
    getVerifyCode();
  };

  const changeSelectColor = (value, key) => {
    let node = document.getElementById(`select-label-${key}`).parentElement
      .childNodes[1];
    node.style.color = value ? "black" : "#b8b7ba";
  };

  const validateSubmit = (values) => {
    const errors = formValidate(values, { profile, getCode });
    console.log(values);
    if (!isEmpty(errors)) {
      setShowModal(errors);
    } else {
      return onSubmit(values);
    }
  };

  // for selector color
  useEffect(() => {
    if (!profile) return;
    Object.keys(profile).forEach((key) => {
      if ((formState[key] || {}).type === "select") {
        changeSelectColor(profile[key], key);
      }
    });
  }, [profile]);

  const disabledSubmitSmsBtn =
    getCode ||
    !phoneFormValue ||
    !phoneFormValue.match(/^(09)[0-9]{8}$/) ||
    isCodeVerified;

  const disabledVerifyInput =
    isCodeVerified ||
    !phoneFormValue ||
    !phoneFormValue.match(/^(09)[0-9]{8}$/);

  return (
    <FormWrapper>
      {submitting && <Loading />}
      <img alt="logo" src={logoQa} width="100%" />
      <form onSubmit={handleSubmit(validateSubmit)} className="form">
        <div className="form-row name">
          <Field
            disabled={submitting}
            {...formState.lastName}
            id="last-name"
            component={renderField}
            className="form_input"
          />
          <Field
            disabled={submitting}
            {...formState.firstName}
            id="first-name"
            component={renderField}
            className="form_input"
          />
        </div>
        <div className="form-row gender">
          <Field
            disabled={submitting}
            {...formState.gender}
            id="gender"
            value={gender}
            component={renderField}
          />
        </div>
        <div className="form-row year">
          <Field
            disabled={submitting}
            {...formState.birthdayYear}
            id="birthdayYear"
            onChange={(e) => changeSelectColor(e.target.value, "birthdayYear")}
            component={renderField}
          />
          <Field
            disabled={submitting}
            {...formState.birthdayMonth}
            id="birthdayMonth"
            onChange={(e) => changeSelectColor(e.target.value, "birthdayMonth")}
            component={renderField}
          />
          <Field
            disabled={submitting}
            {...formState.birthdayDay}
            id="birthdayDay"
            onChange={(e) => changeSelectColor(e.target.value, "birthdayDay")}
            component={renderField}
          />
        </div>
        <div className="form-row phone">
          <Field
            disabled={submitting}
            {...formState.phone}
            id="phone"
            onChange={onPhoneChange}
            component={renderField}
            className="form_input"
          />
          <div>
            <InputLabel>手機</InputLabel>
            <LoadingButton
              variant="contained"
              onClick={sendVerify}
              className="code_btn"
              loading={codeSubmitting}
              disabled={disabledSubmitSmsBtn}
            >
              {isCodeVerified ? "已驗證" : "索取驗證碼"}
            </LoadingButton>
          </div>
        </div>
        <div className="form-row one-child">
          <Field
            disabled={submitting || disabledVerifyInput}
            {...formState.verifySms}
            id="verifySms"
            className="form_input"
            component={renderField}
          />
        </div>
        <div className="form_timer">
          {getCode && <Timer />}
          {verifyError && <Typography color="red">驗證碼錯誤</Typography>}
        </div>
        <div className="form-row one-child">
          <Field
            disabled={submitting}
            {...formState.email}
            id="email"
            className="form_input"
            component={renderField}
          />
        </div>
        <div className="form-row one-child">
          <Field
            disabled={submitting}
            {...formState.store}
            id="store"
            options={formatStoreList}
            onChange={(e) => changeSelectColor(e.target.value, "store")}
            component={renderField}
          />
        </div>
        <p className="note">*為必填項目</p>
        <div className="privacy_content">
          <Typography variant="subtitle2">隱私權聲明</Typography>
          <div className="border_white" />
          <div className="content">
            <Typography variant="string">
              若您點選下方“我同意”並提交問券，即表示您同意我們的隱私權政策。
            </Typography>
          </div>
          <Typography variant="string" className="privacy_check">
            <Field
              disabled={submitting}
              {...formState.privacy}
              id="check"
              component={renderField}
            />
            <span
              className="privacy-btn"
              onClick={() => setShowModal("privacy")}
            >
              我同意La Prairie隱私權政策
            </span>
          </Typography>
        </div>
        <LoadingButton
          type="submit"
          size="large"
          variant="contained"
          className="submit_btn"
          loading={submitting}
        >
          送出問卷
        </LoadingButton>
      </form>
    </FormWrapper>
  );
};

const QuestionnaireForm = reduxForm({
  form: "laPrairieForm",
})(Questionnaire);

const mapStateToProps = (state, { profile }) => {
  return {
    initialValues: profile,
  };
};

export default connect(null, mapStateToProps)(QuestionnaireForm);
